/**
 * System Health Service
 * Handles system health report data fetching
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { generateMockSystemHealthData } from '../mock/mockSystemHealth';
import { delay } from '../mock/mockData';
import type { SystemHealthData, ReportFilters } from '../../types/reports';

class SystemHealthService {
  /**
   * Get system health report data
   */
  static async getSystemHealthData(
    filters?: ReportFilters
  ): Promise<SystemHealthData> {
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
      return generateMockSystemHealthData();
    } else {
      const params = new URLSearchParams();
      
      if (filters?.dateRange) params.append('dateRange', filters.dateRange);
      if (filters?.region) params.append('region', filters.region);
      
      const response = await fetch(`/api/reports/system-health?${params.toString()}`);
      if (!response.ok) {
        throw new Error('Failed to fetch system health data');
      }
      return response.json();
    }
  }
}

export { SystemHealthService };

